import { Product } from '@inter-ikea-storageone/range';

const getUnavailableProductParts = (product: Product) => {
  return product.parts.filter(part => {
    if (part.product && !part.product.valid) {
      return true;
    }
    return false;
  });
};

const getUnavailableShoppingProducts = (
  unavailableProductsinScene: string[],
  allUnavailableProducts: Product[]
): Product[] => {
  const products: Product[] = [];

  const findUnavailableProduct = (id: string) => {
    return allUnavailableProducts.find(p => p.coreProductId === id);
  };

  const findUnavailablePart = (id: string) => {
    return allUnavailableProducts.find(p => p.ruItemNo === id);
  };

  const addProduct = (product: Product) => {
    products.push(product);
  };

  unavailableProductsinScene.forEach(id => {
    const product = findUnavailableProduct(id);
    if (product) {
      const unavailableProductParts = getUnavailableProductParts(product);
      if (unavailableProductParts && unavailableProductParts.length > 0) {
        unavailableProductParts.forEach(part => {
          const productPart = findUnavailablePart(part.id);
          if (productPart) {
            addProduct(productPart);
          }
        });
      } else {
        addProduct(product);
      }
    }
  });

  return products;
};

export default getUnavailableShoppingProducts;
